import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-[#FBFBFD]">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-white/70 border-b border-[#E8E8ED]">
        <div className="max-w-3xl mx-auto px-4 md:px-6 h-14 flex items-center gap-3">
          <Link to="/" className="p-2 -ml-2 rounded-full hover:bg-[#F5F5F7]" data-testid="back-btn">
            <ArrowLeft className="w-5 h-5 text-[#0A2540]" />
          </Link>
          <img src="/taip-logo.png" alt="" className="w-8 h-8 rounded-full" />
          <div className="font-semibold text-[#0A2540]">{title}</div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        <article className="prose prose-slate max-w-none text-[#1D1D1F] leading-relaxed">
          {children}
        </article>
        <div className="text-xs text-gray-400 mt-10 pt-6 border-t border-[#F5F5F7]">
          © {new Date().getFullYear()} Tripstar. All rights reserved.
        </div>
      </main>
    </div>
  );
}
